import { render, staticRenderFns } from "./WargaDetail.vue?vue&type=template&id=a4afbfe2&scoped=true&"
import script from "./WargaDetail.vue?vue&type=script&lang=js&"
export * from "./WargaDetail.vue?vue&type=script&lang=js&"
import style0 from "./WargaDetail.vue?vue&type=style&index=0&id=a4afbfe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4afbfe2",
  null
  
)

export default component.exports